module.exports = __webpack_public_path__ + "img/bankIcon.87fbaafd.svg";